import { useEffect, useState } from "react";
import { Languages } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { Stars } from "@/components/reviews/Stars";

// One review; text is rendered as plain React text (escaped). Lazy translation into the visitor's language.
export const ReviewItem = ({ review, url, actions }) => {
  const { t, lang, fmtDate } = useI18n();
  const [tr, setTr] = useState(null);
  const [original, setOriginal] = useState(false);

  useEffect(() => {
    setTr(null);
    setOriginal(false);
    if (!url || !review.text || review.lang === lang) return;
    let live = true;
    api.get(`${url}/${review.id}/translation`, { params: { lang } })
      .then(({ data }) => live && data.translated && setTr(data.text))
      .catch(() => {});
    return () => { live = false; };
  }, [url, review.id, review.text, review.lang, lang]);

  const shown = tr && !original ? tr : review.text;
  return (
    <li className="min-w-0 rounded-2xl border border-[rgba(245,197,66,0.18)] bg-black/30 p-4" data-testid={`review-${review.id}`}>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <Stars value={review.stars} testId={`review-stars-${review.id}`} />
        <span className="min-w-0 break-words [overflow-wrap:anywhere] font-semibold text-white" data-testid={`review-pseudo-${review.id}`}>{review.pseudo}</span>
        {review.mine && <span className="rounded-full border border-[var(--gold)] px-2 py-0.5 text-[0.65rem] text-[var(--gold-bright)]">{t("reviews.mine")}</span>}
      </div>
      <p className="mt-1 text-[0.7rem] text-neutral-500">
        {fmtDate(review.created_at)}{review.edited ? ` · ${t("reviews.edited")}` : ""}{review.version ? ` · ${t("reviews.version", { v: review.version })}` : ""}
        {review.app_name ? ` · ${review.app_name}` : ""}{review.developer ? ` (${review.developer})` : ""}
      </p>
      {review.text && (
        <p className="mt-2 whitespace-pre-line break-words [overflow-wrap:anywhere] text-sm leading-relaxed text-neutral-200" data-testid={`review-text-${review.id}`}>{shown}</p>
      )}
      {tr && (
        <button type="button" className="mt-2 inline-flex items-center gap-1 text-xs text-[var(--gold)] underline-offset-4 hover:underline" onClick={() => setOriginal((o) => !o)} data-testid={`review-original-toggle-${review.id}`}>
          <Languages className="h-3.5 w-3.5" /> {t(original ? "reviews.showTranslation" : "reviews.showOriginal")}
        </button>
      )}
      {actions && <div className="mt-3 flex flex-wrap gap-2">{actions}</div>}
    </li>
  );
};
